import { LucideIcon } from "lucide-react";
import { Card, CardContent } from "../../../../../components/ui/card";

interface CheckoutStatCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  valueType?: "integer" | "cents" | "text";
}

export function CheckoutStatCard({
  title,
  value,
  icon: Icon,
  valueType = "text",
}: CheckoutStatCardProps) {
  const formatValue = () => {
    if (valueType === "integer") {
      return Number(value).toLocaleString("pt-BR");
    }
    if (valueType === "cents") {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(value) / 100);
    }
    return value;
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground">{title}</p>
            <p className="text-2xl font-bold">{formatValue()}</p>
          </div>
          <Icon className="h-8 w-8 text-muted-foreground" />
        </div>
      </CardContent>
    </Card>
  );
}
